Controller.$inject = ['$element', '$timeout'];

function Controller($element, $timeout) {
    const self = this;
    self.pagesList = [];

    self.$onInit = () => {
        self.generatePagesList();
        self.setupPageButtonClickHandler();
        self.triggerFirstPageButtonClick();
    };

    self.$onChanges = (changes) => {
        if (changes.count || changes.page) {
            self.generatePagesList();
            self.updateHoveredClass(self.page);
        }
    };

    self.generatePagesList = () => {
        const totalPages = self.count || 1;
        const maxVisible = self.maxNumber || 5;
        const currentPage = self.page || 1;
        const pages = [1];

        if (totalPages <= maxVisible) {
            for (let i = 2; i < totalPages; i++) {
                pages.push(i);
            }
        } else if (currentPage <= 3) {
            for (let i = 2; i <= 3; i++) {
                pages.push(i);
            }
            pages.push('ellipsis');
        } else if (currentPage >= totalPages - 2) {
            pages.push('ellipsis');
            for (let i = totalPages - 2; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push('ellipsis');
            pages.push(currentPage - 1, currentPage, currentPage + 1);
            pages.push('ellipsis');
        }

        pages.push(totalPages);

        self.pagesList = pages.length > maxVisible ? pages.slice(0, maxVisible - 1).concat(totalPages) : pages;

        $element.find('.page-btn').each(function () {
            const button = angular.element(this);
            const page = button.text().trim();
            if (page === 'ellipsis') {
                button.addClass('ellipses');
            }
        });
    };

    self.setupPageButtonClickHandler = () => {
        $element.on('click', '.page-btn', function () {
            $element.find('.page-btn').removeClass('active');
            angular.element(this).addClass('active');
        });
    };

    self.triggerFirstPageButtonClick = () => {
        $timeout(() => {
            const firstPageBtn = $element.find('.page-btn').first();
            if (firstPageBtn.length) {
                firstPageBtn.trigger('click');
            }
        }, 0);
    };

    self.prevPage = () => {
        self.handlePageChange('prev');
    };

    self.nextPage = () => {
        self.handlePageChange('next');
    };

    self.handlePageChange = (direction) => {
        if (self.itemsVariant === 'total') {
            self.handleTotalVariant(direction);
        }

        if (self.itemsVariant === 'discrete') {
            self.handleDiscreteVariant(direction);
        }

        if (direction === 'prev' && self.page > 1) {
            self.page--;
        } else if (direction === 'next' && self.page < self.count) {
            self.page++;
        }

        self.triggerPageChange();
        self.generatePagesList();
        self.updateHoveredClass(self.page);
    };

    self.handleTotalVariant = (direction) => {
        const totalView = $element.find('.total-view');
        if (direction === 'prev' && self.page !== self.count - 1) {
            totalView.removeClass('last-page');
        } else if (direction === 'next' && self.page === self.count - 1) {
            totalView.addClass('last-page');
        }
    };

    self.handleDiscreteVariant = (direction) => {
        const lastPageBtn = $element.find('.page-btn');
        if (direction === 'prev') {
            lastPageBtn.removeClass('last-page');
        } else if (direction === 'next') {
            lastPageBtn.addClass('last-page');
        }
    };

    self.setPage = (page) => {
        if (typeof page === 'number' && page >= 1 && page <= self.count) {
            const pageBtn = $element.find('.page-btn');
            pageBtn.removeClass('last-page');
            self.page = page;
            self.triggerPageChange();
            self.generatePagesList();
            self.updateHoveredClass(self.page);

            if (self.page === self.count) {
                self.handleDiscreteVariant('next');
            }
        }
    };

    self.triggerPageChange = () => {
        if (self.onPageChange) {
            self.onPageChange({ page: self.page });
        }
    };

    self.updateHoveredClass = (pageNumber) => {
        const pageButtons = $element.find('.page-btn');
        pageButtons.removeClass('active');
        const activeButtonIndex = self.pagesList.indexOf(pageNumber);

        if (activeButtonIndex !== -1) {
            pageButtons.eq(activeButtonIndex).addClass('active');
        }
    };

    self.isNumber = (value) => {
        return typeof value === 'number';
    };
}

export function HuiPaginator() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            variant: '@',
            itemsVariant: '@',
            count: '<',
            page: '<',
            maxNumber: '<',
            onPageChange: '&'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: `
            <div class="hui hui-paginator" 
                 ng-class="[($huiCtrl.variant || 'ghost'),
                            ($huiCtrl.itemsVariant || 'discrete')]">
                <hui-button-group class="hui-paginator-container">
                    <hui-button variant="{{($huiCtrl.variant || 'ghost')}}"
                                ng-click="$huiCtrl.prevPage()"
                                ng-disabled="$huiCtrl.page === 1">
                        <i class="fa-solid fa-chevron-left"></i>
                    </hui-button>
                    
                    <hui-button ng-if="$huiCtrl.itemsVariant === 'discrete'"
                                variant="{{($huiCtrl.variant || 'ghost')}}"
                                ng-repeat="page in $huiCtrl.pagesList track by $index"
                                class="page-btn"
                                ng-click="page === 'ellipsis' ? $event.stopPropagation() : $huiCtrl.setPage(page)">
                           <span ng-if="$huiCtrl.isNumber(page)">{{page}}</span>
                           <i ng-if="page === 'ellipsis'" class="fa fa-ellipsis-h"></i>
                    </hui-button>
                    
                    <hui-button ng-if="$huiCtrl.itemsVariant === 'total'"
                                 variant="{{($huiCtrl.variant || 'ghost')}}"
                                 class="total-view">
                        {{$huiCtrl.page}} / {{$huiCtrl.count}}
                    </hui-button>

                    
                    <hui-button variant="{{($huiCtrl.variant || 'ghost')}}"
                                ng-click="$huiCtrl.nextPage()"
                                ng-disabled="$huiCtrl.page === $huiCtrl.count">
                        <i class="fa-solid fa-chevron-right"></i>
                    </hui-button>
                </hui-button-group>
            </div>
        `
    };
}
